import apiInternal from './servers/apiInternal';

export interface PushRequestItem {
  cnjParamReqId: string;
  cnjParamId: string;
  requestId: string | null;
  status: string;
  secret: boolean;
  type: 'cadastro' | 'reprocessamento' | 'monitoramento';
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  platform: string | null;
  search: string | null;
  query: string | null;
  param: string | null;
  public: boolean | null;
  justiceSecret: boolean | null;
}

export interface PushReportResponse {
  success: boolean;
  data: PushRequestItem[];
}

const pushReport = {
  getReportRequests: async (id: string): Promise<PushReportResponse> => {
    try {
      const res = await apiInternal.get(`/push/report/requests/${id}`);
      // A API do push retorna { success: true, data: [...] }
      if (res.data && res.data.success !== undefined) {
        return {
          success: res.data.success,
          data: Array.isArray(res.data.data) ? res.data.data : [],
        };
      }
      // Fallback caso a resposta venha diretamente como array
      if (Array.isArray(res.data)) {
        return {
          success: true,
          data: res.data,
        };
      }
      // Se não tem data, retorna array vazio
      return {
        success: res.data?.success || false,
        data: [],
      };
    } catch (error: any) {
      // Se for 404, retorna array vazio (pode não ter requests ainda)
      if (error.response?.status === 404) {
        return {
          success: true,
          data: [],
        };
      }
      // Para outros erros, relança para ser tratado no componente
      throw error;
    }
  },
};

export default pushReport;
